import type { FaireProductEntity } from "../../entity_types/product";

export const p_4956p8ks8z: FaireProductEntity = {
  token: "p_4956p8ks8z",
  type: "product",
  name: "Textured Knit Button-Up Long Sleeve Sweater Cardigan",
  brandToken: "b_b5qvtl6s4w",
  brandName: "PRETTY BASH",
  imageUrl:
    "https://cdn.faire.com/fastly/3d0e2479c6e04ab6a1f59efb4942da495f56ff1b38c58fd634f440af9e8926ae.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/90690b3fce16d03881ba6a45917b87bc1922c0fb687e78750f7ba9810d7fe262.jpeg",
    "https://cdn.faire.com/fastly/e8001243c5cbe4043aebd4ee73f3913bff4cbbf7cffd879fa0d7a9153c8860e1.jpeg",
    "https://cdn.faire.com/fastly/13270554c69aaf5f769b36b99a0443058edd76d47f04e34256fe91c5442a3361.jpeg",
    "https://cdn.faire.com/fastly/21ed66e0c5591ccdf4070482308a1bf93831436b34928437e04b572430721e5b.jpeg",
    "https://cdn.faire.com/fastly/dc53828539da8d18435fd92d9e1c8e498937535b6a69322ffe80f0dc68739105.jpeg",
    "https://cdn.faire.com/fastly/1199f7e66ea332a90940a8db75edef53b98894f8523dd8ffc311e7d3a59b7261.png",
  ],
  priceDollars: 33,
  description:
    "Elevate your everyday style with this chic sweater cardigan that's anything but ordinary. Featuring a round neckline, warm wooden button closures, and a relaxed fit, it's the perfect piece for expressing your personal flair. The solid hue pairs effortlessly with everything in your wardrobe, making it a go-to for creating those coveted minimalist looks. Whether you're layering over a dress or pairing with your favorite jeans, this versatile cardigan brings understated elegance to every outfit. Acrylic/Polyester/Poly\n\n\nSize Info:\nSee size chart for approximate measurements.\n\nSeason: Fall, Winter, Spring\n\n",
  tags: [],
  msrpDollars: 66,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:27.039Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
